import type { SavedViewConfig } from "@/components/shared/UniversalCRMTable/types";

export const offeringSavedViews: SavedViewConfig[] = [
  {
    id: "all-offerings",
    name: "All Offerings",
    filters: {},
    isDefault: true,
    visibleColumns: [
      "title",
      "description",
      "tags",
      "total_hours",
      "total_hard_costs",
      "total_cost",
      "created_at",
    ],
  },
  {
    id: "recent",
    name: "Recently Updated",
    filters: {},
    visibleColumns: [
      "title",
      "tags",
      "total_hours",
      "total_cost",
      "updated_at",
    ],
  },
];
